import React, { useState, useEffect } from "react";
import SkeletonCard from "../../elements/loading/SkeletonCard";
import NotFound from "../../elements/not-found/NotFound";
import SMSelect from "../../elements/select/SMSelect";
import axiosAPI from "../../utils/axios-api";
import PartisipasiBox from "./components/PartisipasiBox";
import PartisipasiTable from "./components/PartisipasiTable";

const API = process.env.REACT_APP_API;

export default function Partisipasi() {
  const [selectedType, setselectedType] = useState("grid");
  const [data, setdata] = useState([]);
  const [loadingGetData, setloadingGetData] = useState(0);

  const [nextPaginate, setNextPaginate] = useState(0);
  const [prevPaginate, setPrevPaginate] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [lastPage, setLastPage] = useState(0);
  const [perPage, setPerPage] = useState(0);
  const [fromPage, setFromPage] = useState(0);
  const [toPage, setToPage] = useState(0);
  const [showPerPage, setShowPerPage] = useState(0);

  let type = [
    { value: "table", label: "table" },
    { value: "grid", label: "grid" },
  ];

  useEffect(() => {
    getPartisipasi();
  }, []);

  function getPartisipasi(params) {
    setloadingGetData(1);
    axiosAPI
      .get(API + "responden/my-partisipasi?page[size]=10&page[number]=1&sort=-created_at")
      .then((res) => {
        setloadingGetData(2);
        setdata(res.data.data);

        setNextPaginate(res.data.meta.current_page + 1)
        setPrevPaginate(res.data.meta.current_page - 1)
        setCurrentPage(res.data.meta.current_page)
        setLastPage(res.data.meta.last_page)
        setPerPage(res.data.meta.per_page)
        setFromPage(res.data.meta.from)
        setToPage(res.data.meta.to)

        if (res.data.data.length === 0) {
          setloadingGetData(4);
        }
      })
      .catch((err) => {
        setloadingGetData(3);
      });
  }

  // paginate
  function nextPage(){

    let nextPage = nextPaginate;
    let pageNow = currentPage;
    let pageLast = lastPage;
    let pageSize = showPerPage ? showPerPage : 10 

    if( pageNow >= pageLast ){
      return false;
    }else{
      let datauser = JSON.parse(localStorage.getItem("authenticatedUser")) ?? {};
    
      axiosAPI
        .get(
          API +
            "responden/my-partisipasi?page[size]="+ pageSize +"&page[number]="+ nextPage +"&sort=-created_at"
        )
        .then((res) => {
          setloadingGetData(2);
          
          setNextPaginate(res.data.meta.current_page + 1)
          setPrevPaginate(res.data.meta.current_page - 1)
          setCurrentPage(res.data.meta.current_page)
          setLastPage(res.data.meta.last_page)
          setPerPage(res.data.meta.per_page)
          setFromPage(res.data.meta.from)
          setToPage(res.data.meta.to)
          
          setdata(res.data.data);
          if (res.data.data.length === 0) {
            setloadingGetData(4);
          }
        })
        .catch((err) => {
          setloadingGetData(3);
        });

    }

  }

  function prevPage(){
    let prevPage = prevPaginate;
    let pageNow = currentPage;
    let pageLast = lastPage;
    let pageSize = showPerPage ? showPerPage : 10 

    if( pageNow === 1 ){
      return false;
    }else{
      let datauser = JSON.parse(localStorage.getItem("authenticatedUser")) ?? {};
    
      axiosAPI
        .get(
          API +
            "responden/my-partisipasi?page[size]="+ pageSize +"&page[number]="+ prevPage +"&sort=-created_at"
        )
        .then((res) => {
          setloadingGetData(2);
          
          setNextPaginate(res.data.meta.current_page + 1)
          setPrevPaginate(res.data.meta.current_page - 1)
          setCurrentPage(res.data.meta.current_page)
          setLastPage(res.data.meta.last_page)
          setPerPage(res.data.meta.per_page)
          setFromPage(res.data.meta.from)
          setToPage(res.data.meta.to)
          
          setdata(res.data.data);
          if (res.data.data.length === 0) {
            setloadingGetData(4);
          }
        })
        .catch((err) => {
          setloadingGetData(3);
        });

    }

  }

  function gotoPage(params){

        let datauser = JSON.parse(localStorage.getItem("authenticatedUser")) ?? {};
        let pageSize = showPerPage ? showPerPage : 10 
        
        axiosAPI
        .get(
            API +
            "responden/my-partisipasi?page[size]="+ pageSize +"&page[number]="+ params +"&sort=-created_at"
        )
        .then((res) => {
            setloadingGetData(2);
            
            setNextPaginate(res.data.meta.current_page + 1)
            setPrevPaginate(res.data.meta.current_page - 1)
            setCurrentPage(res.data.meta.current_page)
            setLastPage(res.data.meta.last_page)
            setPerPage(res.data.meta.per_page)
            setFromPage(res.data.meta.from)
            setToPage(res.data.meta.to)
            
            setdata(res.data.data);
            if (res.data.data.length === 0) {
            setloadingGetData(4);
            }
        })
        .catch((err) => {
            setloadingGetData(3);
        });

  }

  function showPage(params){
    let datauser = JSON.parse(localStorage.getItem("authenticatedUser")) ?? {};
    setShowPerPage(params)
        
    axiosAPI
    .get(
        API +
        "responden/my-partisipasi?page[size]="+ params +"&page[number]="+ currentPage +"&sort=-created_at"
    )
    .then((res) => {
        setloadingGetData(2);
        
        setNextPaginate(res.data.meta.current_page + 1)
        setPrevPaginate(res.data.meta.current_page - 1)
        setCurrentPage(res.data.meta.current_page)
        setLastPage(res.data.meta.last_page)
        setPerPage(res.data.meta.per_page)
        setFromPage(res.data.meta.from)
        setToPage(res.data.meta.to)
        
        setdata(res.data.data);
        if (res.data.data.length === 0) {
        setloadingGetData(4);
        }
    })
    .catch((err) => {
        setloadingGetData(3);
    });
  }

  function renderData(params) {
    switch (loadingGetData) {
      case 1:
        return (
          <div>
            <SkeletonCard />
            <SkeletonCard />
            <SkeletonCard />
          </div>
        );
        break;
      case 2:
        return (
          <>
            {selectedType !== "grid" ? (
              <PartisipasiTable
                data={data}
                onRefresh={() => getPartisipasi()}
              />
            ) : (
              <>
                {data.map((val, idx) => {
                  return (
                    <PartisipasiBox
                      key={idx}
                      data={val}
                      onRefresh={() => getPartisipasi()}
                    />
                  );
                })}
              </>
            )}

            <div class="flex">

            <div class="inline-flex mt-2 xs:mt-0">

                <button onClick={() => prevPage()} class="inline-flex items-center py-2 px-2 mr-3 text-sm font-medium text-gray-500 bg-white rounded-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">
                    <svg class="mr-2 w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z" clip-rule="evenodd"></path>
                    </svg>
                </button>

                <button onClick={() => nextPage()} class="inline-flex items-center py-2 px-2 text-sm font-medium text-gray-500 bg-white rounded-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">
                    <svg class="ml-2 w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd"></path>
                    </svg>
                </button>

            </div>

            <span class="text-sm text-gray-700 dark:text-gray-400 mt-4 ml-3 xs:mt-0 font-medium">
                  {fromPage} - {toPage} Dari {lastPage} Page |
                <input class="shadow appearance-none border rounded w-20 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ml-2" type="number" name="" id="" onChange={evt => gotoPage(evt.target.value)} value={currentPage} />

                <select class="shadow appearance-none border rounded w-20 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ml-2" name="" id="" onChange={evt => showPage(evt.target.value)}>
                    {/* <option value="5">Show 5</option> */}
                    <option value="10">Show 10</option>
                    <option value="30">Show 30</option>
                    <option value="40">Show 40</option>
                    <option value="50">Show 50</option>
                </select>

            </span>

            </div>
          </>
        );
        break;
      case 3:
        return (<div>error</div>)
        break;
      case 4:
        return (
          <div>
            <NotFound/>
          </div>
        )
        break;

      default:
        break;
    }
  }
  return (
    <div
      className="w-full flex flex-col p-10 dark:text-white"
      style={{ minHeight: "100vh" }}
    >
      <div className="block mb-8">
        <div className="flex">
          <h1 className="text-3xl font-bold mr-4">Partisipasi</h1>
          <div className="flex w-40">
            <SMSelect
              data={type}
              defaultValue={type[1]}
              onChange={(e) => setselectedType(e.value)}
            />
          </div>
        </div>
      </div>

      <div className="flex flex-col">{renderData()}</div>
    </div>
  );
}
